module.exports = __webpack_public_path__ + "assets/img/33.95cdbe84.png";